export default __webpack_public_path__ + "static/media/Hair_1_M_C2.ee0ee361.svg";